import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: '100%',
    padding: '1rem',
  },
  actionTypography: {
    cursor: 'pointer',
  },
  topContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '1rem',
    borderRadius: '0.75rem',
    border: '1px solid #DCDFE1',
    padding: '1.5rem',
  },
}));

export default useStyles;
